/**
 * Actual duration (100) plus some buffer.
 */
export const DRAWER_TRANSITION_DURATION = 150;
